import {
  ButtonComp,
  SelectComp2,
  TextInputComp,
  MoneyInputComp,
  CardComp,
  FormikSelectComp,
} from "../../../../components";
import { Formik, Form } from "formik";
import { useEditRegFeeMutation } from "../../../../store/admin/settings/regFeeSlice";
import { useGetFeeCategoriesQuery } from "../../../../store/selectableSlice";
import { toast } from "react-hot-toast";
import { useState, useEffect } from "react";
import { FaTag, FaDollarSign, FaFileInvoiceDollar } from "react-icons/fa";

export default function EditNewRegistrationFee({ onNext, initialValues }) {
  const { data: feeCategories = [], error: errorFeeCat, isLoading: isLoadingCategories } = useGetFeeCategoriesQuery();
  const [editRegFee] = useEditRegFeeMutation();
  const [newAmount, setNewAmount] = useState(initialValues?.amount || "");
  const [fee_category_id, setCatId] = useState(initialValues?.fee_category_id || "");

  useEffect(() => {
    if (initialValues?.amount) {
      setNewAmount(initialValues.amount);
    }
    if (initialValues?.fee_category_id) {
      setCatId(initialValues.fee_category_id);
    }
  }, [initialValues]);

  const updateRegFee = async (formikValues) => {
    const reqBody = {
      ...formikValues,
      amount: newAmount,
      fee_category_id: fee_category_id,
    };
    const toastId = toast.loading("Updating fee");
    const { data, error } = await editRegFee(reqBody);
    if (error) {
      return toast.error(error?.data?.message || "Error updating fee", { id: toastId });
    }
    if (data?.status === false) {
      return toast.error(data?.message || "Error updating fee", { id: toastId });
    }
    return toast.success(data?.message || "Fee updated successfully", { id: toastId });
  };
  
  if (!initialValues) {
    return null;
  }

  // Get the selected category option for SelectComp2
  const selectedCategoryOption = feeCategories.find(
    (cat) => cat.id === fee_category_id || cat.id === initialValues?.fee_category_id
  );

  return (
    <div className="mt-3">
      <Formik 
        initialValues={{
          id: initialValues?.id,
          name: initialValues?.name || "",
          fee_category_id: initialValues?.fee_category_id || "",
          amount: initialValues?.amount || "",
        }} 
        onSubmit={updateRegFee}
      >
        <Form>
          <CardComp
            cardBodyClassName={"row py-0 gx-5 gy-4"}
            cardClassName={"border-0 rounded-10 px-lg-4 mb-4 pt-4 shadow3"}
          >
            <div className="col-12 mb-2">
              <h5 className="fw-bold mb-1 text-black1">
                Fee Information
              </h5>
              <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                Update the details for this member registration fee
              </p>
            </div>
            
            <div className="col-12 col-lg-6">
              <div className="mb-4">
                <label className="d-flex align-items-center mb-2 fw-bold text-black1">
                  <FaFileInvoiceDollar className="me-2" style={{ color: "var(--color-primary)", fontSize: "16px" }} />
                  Fee Name
                </label>
                <TextInputComp
                  placeholder={"e.g., Registration Fee, Form Fee"}
                  name="name"
                  required
                />
              </div>
            </div>

            <div className="col-12 col-lg-6">
              <div className="mb-4">
                <label className="d-flex align-items-center mb-2 fw-bold text-black1">
                  <FaTag className="me-2" style={{ color: "var(--color-primary)", fontSize: "16px" }} />
                  Fee Category
                  <span className="text-danger ms-1">*</span>
                </label>
                <SelectComp2
                  placeholder={initialValues?.fee_category_name || "Select Fee Category"}
                  arrayComp={[
                    ...feeCategories.map((fee) => ({
                      value: fee.id,
                      label: fee.name,
                    })),
                  ]}
                  setSelectedOption={({ value }) => {
                    setCatId(value);
                  }}
                  selectedOption={selectedCategoryOption ? {
                    value: selectedCategoryOption.id,
                    label: selectedCategoryOption.name,
                  } : null}
                  isLoading={isLoadingCategories}
                />
              </div>
            </div>

            <div className="col-12 col-lg-6">
              <div className="mb-4">
                <label className="d-flex align-items-center mb-2 fw-bold text-black1">
                  <FaDollarSign className="me-2" style={{ color: "var(--color-primary)", fontSize: "16px" }} />
                  Fee Amount
                </label>
                <MoneyInputComp
                  placeholder={"Enter amount (e.g., 10,000.00)"}
                  name="amount"
                  defaultValue={initialValues?.amount || ""}
                  handleChange={(value) => setNewAmount(value)}
                  desc="Leave empty if the fee amount varies or is not fixed"
                />
              </div>
            </div>
          </CardComp>

          <div className="d-flex justify-content-end gap-3 mt-4">
            <ButtonComp
              btnText={"Update Fee"}
              type={"submit"}
              btnClassName={
                "bg-primary1 py-2 px-5 fw-bold text-white border-0 rounded"
              }
              style={{ minWidth: "200px" }}
            />
          </div>
        </Form>
      </Formik>
    </div>
  );
}
